module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/andriy-olkhovyy-avatar-7fac20e4e603e9d99e6300d4d79b76ac.jpg";